<template>
  <div>
    <ValidationProvider :rules="{ required: true }" name="tipo de asistencia" v-slot="{ errors }">
      <b-form-group class="mb-2">
        <template #label>
          <span>Seleccionar dirección</span><span class="asterisk">*</span>
          <span v-if="!clientId" class="text-info fs-12 ml-2">
            <font-awesome-icon :icon="['far', 'info-circle']" size="sm" />
            Debe seleccionar un cliente primero
          </span>
        </template>
        <b-select
          v-model="selectedAddressId"
          :options="addressOptions"
          :state="(errors[0] || !addressForm.client_address_id) ? false : null"
          @change="onAddressSelect"
        >
          <template #first>
            <option :value="null">-- Seleccionar --</option>
          </template>
        </b-select>
      </b-form-group>
    </ValidationProvider>

    <ValidationProvider :rules="{ required: true }" name="tipo de asistencia" v-slot="{ errors }">
      <b-form-group class="mb-2">
        <template #label>
          <span>Tipo de asistencia</span><span class="asterisk">*</span>
        </template>
        <b-select
          v-model="addressForm.assistance_type"
          :options="assistanceTypeOptions"
          :state="errors[0] ? false : null"
          @change="onChangeAssistanceType"
        >
          <template #first>
            <option :value="null" disabled>-- Seleccionar --</option>
          </template>
        </b-select>
      </b-form-group>
    </ValidationProvider>

    <template v-if="addressForm.assistance_type === 'En sitio'">
      <b-form-group class="mb-2">
        <template #label>
          <span>Coordenadas geográficas</span>
          <span class="text-muted fs-12">(opcional)</span>
        </template>
        <b-input-group>
          <b-input
            v-model="addressForm.geo_location"
            type="text"
            placeholder="9.9281, -84.0907"
            :state="coordinates.isValid ? null : false"
            @blur="onGeoBlur"
          />
          <!-- <template #append>
            <b-form-checkbox
              v-model="showMap"
              size="lg"
              :value="true"
              :unchecked-value="false"
              class="ml-2 align-self-center"
            >
              <span class="fs-14">Fijar en mapa</span>
            </b-form-checkbox>
          </template> -->
        </b-input-group>
      </b-form-group>

      <b-row v-show="showMap" class="mb-2">
        <b-col>
          <GoogleMaps :coordinates="coordinates" @update-coordinates="onMarkerMove" />
        </b-col>
      </b-row>

      <ValidationProvider :rules="{ required: true, max: 240 }" name="dirección" v-slot="{ errors }">
        <b-form-group class="mb-0">
          <template #label>
            <span>Dirección</span><span class="asterisk">*</span>
          </template>
          <b-textarea
            v-model="addressForm.address"
            placeholder="Ej: Sabana sur 50 este del colegio, 30 mtrs oeste"
            rows="3"
            :state="errors[0] ? false : null"
          />
        </b-form-group>
      </ValidationProvider>
    </template>
  </div>
</template>

<script>
import GoogleMaps        from '../../../../shared/GoogleMaps'
import { ValidationProvider } from 'vee-validate'
import { locationTypeOptions } from '../../../../../sharedOptions/serviceCallModule'

export default {
  name: 'AddressForm',
  components: { GoogleMaps, ValidationProvider },
  props: {
    addressForm: { type: Object, required: true },
    addresses:   { type: Array,  default: () => [] },
    clientId:    { type: [Number, String], default: null },
  },
  data() {
    return {
      selectedAddressId: null,
      showMap:           false,
      coordinates: {
        lat:     9.946588,
        lng:     -84.075483,
        isValid: true,
      },
      geoTimeout: null,
      assistanceTypeOptions: locationTypeOptions,
    }
  },
  mounted () {
    this.selectedAddressId = this.addressForm.client_address_id
  },
  computed: {
    addressOptions() {
      return this.addresses.map(a => ({ text: a.address, value: a.id }))
    },
  },
  watch: {
    clientId(newVal, oldVal) {
      if (newVal != oldVal) this.reset()
    },
  },
  methods: {
    onAddressSelect(id) {
      const a = this.addresses.find(x => x.id === id) || {}
      this.addressForm.client_address_id = a.id           || null
      this.addressForm.address           = a.street       || ''
      this.addressForm.geo_location      = a.geo_location || ''
    },

    onChangeAssistanceType() {
      this.selectedAddressId        = null
      this.addressForm.address      = null
      this.addressForm.geo_location = null
    },

    reset() {
      this.selectedAddressId             = null
      this.addressForm.client_address_id = null
      this.addressForm.address           = ''
      this.addressForm.geo_location      = ''
      this.addressForm.assistance_type   = 'En sitio'
    },
    onGeoBlur() {
      clearTimeout(this.geoTimeout)
      // if (!this.showMap) return

      this.geoTimeout = setTimeout(() => {
        const value = (this.addressForm.geo_location || '').trim()
        const regex = /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/
        if (!regex.test(value)) {
          this.coordinates.isValid = false;
          return
        }
        const [lat, lng] = value.split(',')
        this._setCoordinates({ lat: Number(lat), lng: Number(lng) })
      }, 400)
    },

    onMarkerMove(coords) {
      this._setCoordinates(coords)
      this.addressForm.geo_location = `${this.coordinates.lat}, ${this.coordinates.lng}`
    },

    _setCoordinates(coords) {
      if (this.coordinates.lat === coords.lat && this.coordinates.lng === coords.lng) return
      this.coordinates = { lat: Number(coords.lat), lng: Number(coords.lng), isValid: true }
    },
  },
}
</script>

<style scoped>
.asterisk { color: #dc2626; margin-left: 2px; }
</style>
